export function Skeleton({ className, style, ...props }) {
	return <div className={`skeleton ${className}`} style={style} {...props} />;
}

export default function ProductSkeleton() {
	return (
			<div className="skeleton-wrapper row">
				<Skeleton className="rounded mb-3 col-md-5 h-big"/>
				<div className="col-md-7">
					<Skeleton className="h-3 w-100"/>
					<Skeleton className="mt-3 h-3 w-100"/>
					<Skeleton className="mt-3 h-3 w-100"/>
					<Skeleton className="mt-3 h-3 w-50"/>
					<div className="d-flex mt-3">
						<Skeleton className="rounded" style={{width: "40px", height: "40px"}}/>
						<Skeleton className="rounded ms-2" style={{width: "40px", height: "40px"}}/>
						<Skeleton className="rounded ms-2" style={{width: "40px", height: "40px"}}/>
					</div>
					
				</div>
			</div>
	);
}
